/**
 * bigflow.site - Marketing Site
 * 
 * Routes:
 * - / (Home - bigflowdata company)
 * - /pairs (bigflow.pairs product page with integrated pricing)
 * - /about
 * - /contact
 * - /privacy, /terms
 * - /pricing → redirects to /pairs#pricing
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { PairsProduct } from './pages/PairsProduct'
import { About } from './pages/About'
import { Contact } from './pages/Contact'
import { Privacy } from './pages/legal/Privacy'
import { Terms } from './pages/legal/Terms'

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/pairs" element={<PairsProduct />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        {/* Redirect old pricing page to pairs product page */}
        <Route path="/pricing" element={<Navigate to="/pairs#pricing" replace />} />
      </Route>
    </Routes>
  )
}

export default App
